import { toast } from "@3sc/common-component";
import axios from "axios";
import i18next from "i18next";
import { findDefaultBu } from "../helper/commonHelper";
import { loaderStateChange } from "../store/Slices/loading";
import { ROUTES_PATH } from "./EndPoints";
import { ENUM_EVENT, sendDataToChild } from "./eventEmitter";
import { get } from "lodash";
import { getLocalStorageItem } from "../helper/localStorageHelper";
import TagManager from "react-gtm-module";

export const apiIpPort = import.meta.env.VITE_IAM_API_ENDPOINT;
export const apiBaseUrl = import.meta.env.VITE_IAM_API_BASEURL;
export const configurationApiEndpoint = import.meta.env
  .VITE_CONFIGURATION_API_ENDPOINT;
export const alertApiEndpoint = import.meta.env.VITE_ALERT_API_ENDPOINT;
export const isDemoAvl = import.meta.env.VITE_IS_DEMO_AVL === "true";
const snopEndpoint = import.meta.env.VITE_SNOP_API_ENDPOINT;
const configurationApiBaseUrl = import.meta.env.VITE_CONFIGURATION_API_BASEURL;
const OKTA_HOST = import.meta.env.VITE_OKTA_HOST;
export const HOST = import.meta.env.VITE_CLIENT_HOST;
export const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
const CLIENT_CODE = import.meta.env.VITE_CLIENT_CODE;
const OKTA_CALLBACK = import.meta.env.VITE_OKTA_CALLBACK ?? "";
const REDIRECT_URI = `${HOST}${OKTA_CALLBACK}`;
const DEFAULT_KEY_CODE = import.meta.env.VITE_DEFAULT_CODE;
const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

const configWithCreds = {
  ...config,
  withCredentials: true,
};

export const setUserData = (user) => {
  const bu = findDefaultBu(user?.business_units || []);
  const selected_business_unit = {
    business_unit_id: bu.business_unit_id,
    business_unit_name: bu.business_unit_name,
  };
  localStorage.setItem(
    "selected_business_unit",
    JSON.stringify(selected_business_unit),
  );
};

export const handleError = (error) => {
  const errorMessage = error?.response?.data?.RESPONSE_CODE;
  toast.error(i18next.t(errorMessage));
};

const defaultBuNotThere = (res) => {
  const user = res.data.data;
  const buArr = user?.business_units;
  const bu = buArr.find((bu) => bu.is_default);
  if (bu) {
    return res;
  }

  return {
    ...res,
    data: {
      ...res.data,
      data: {
        ...user,
        business_units: [
          {
            ...buArr?.[0],
            is_default: true,
          },
          ...buArr?.slice(1),
        ],
      },
    },
  };
};

export const makePostRequest = async (url, body) => {
  try {
    const res = await axios.post(url, body, configWithCreds);
    const user = res.data.data;
    setUserData(user);
    return defaultBuNotThere(res);
  } catch (error) {
    handleError(error);
  }
};

export const captchTokenVerify = async ({ secretKey, token }) => {
  return await axios.post(
    "https://www.google.com/recaptcha/api/siteverify",
    null,
    {
      params: {
        secret: secretKey,
        response: token,
      },
    },
  );
};

export const loginUser = async (email, password, recaptchaToken) => {
  const body = { email, password, recaptcha_token: recaptchaToken };
  return await makePostRequest(`${apiIpPort}${apiBaseUrl}/users/login`, body);
};

export const ssoLogin = async ({ email }) => {
  const url = `${snopEndpoint}/v1/users/microsoft-sso-login-url/?email=${email}`;
  return await axios.get(url);
};

export const ssoAuth = async ({ code, state, email }) => {
  const body = { code, state, email };
  const url = `${snopEndpoint}/v1/users/api/auth/microsoft/`;
  return await axios.post(url, body);
};

export const loginMFA = async (binding_code, oob_code, mfa_token, email) => {
  const body = { binding_code, oob_code, mfa_token, email };
  return await makePostRequest(
    `${apiIpPort}${apiBaseUrl}/users/login_mfa`,
    body,
  );
};

export const validateOKTALogin = async (auth, verifier) => {
  const body = { auth_code: auth, code_verifier: verifier };
  return await makePostRequest(
    `${apiIpPort}${apiBaseUrl}/users/login/okta`,
    body,
  );
};

export const getConfiguration = async (token, tenant_id, bu_id) => {
  try {
    const url = `${configurationApiEndpoint}${configurationApiBaseUrl}?tenant_id=${tenant_id}&bu_id=${bu_id}`;
    const configurationResult = await axios.get(url, configWithCreds);
    localStorage.setItem(
      "configuration",
      JSON.stringify(configurationResult.data.responseData.response),
    );
    return configurationResult;
  } catch (error) {
    handleError(error);
  }
};


export const getUserAPI = async ({ orgId, userId }) => {
  const url = `${apiIpPort}${apiBaseUrl}/org/${orgId}/users/${userId}`;
  return await axios.get(url, configWithCreds);
};

export const editUserAPI = async ({ orgId, userId, payload }) => {
  return await axios.put(
    `${apiIpPort}${apiBaseUrl}/org/${orgId}/users/${userId}`,
    payload,
    configWithCreds,
  );
};

export const setPassword = async (password, token) => {
  const body = { password };
  try {
    const res = await axios.patch(
      `${apiIpPort}${apiBaseUrl}/users/set-password`,
      body,
      configWithCreds,
    );
    return res;
  } catch (error) {
    handleError(error);
  }
};

export const forgotPassword = async (email, recaptchaToken) => {
  const body = { email, recaptcha_token: recaptchaToken };
  try {
    const res = await axios.post(
      `${apiIpPort}${apiBaseUrl}/users/forgot-password`,
      body,
      configWithCreds,
    );
    return res;
  } catch (error) {
    handleError(error);
  }
};

export const resetPassword = async (body) => {
  try {
    const res = await axios.post(
      `${apiIpPort}${apiBaseUrl}/users/reset-password`,
      body,
      configWithCreds,
    );
    return res;
  } catch (error) {
    handleError(error);
  }
};

export const tokenVerify = async (token) => {
  const body = { token };
  return await axios.post(
    `${apiIpPort}${apiBaseUrl}/users/token/verify`,
    body,
    configWithCreds,
  );
};

export const tokenRefresh = async (token, authenticator) => {
  const body = authenticator ? { authenticator: authenticator ?? "" } : {};
  return await axios.post(
    `${apiIpPort}${apiBaseUrl}/users/token/refresh`,
    body,
    configWithCreds,
  );
};

export const authorizeOkta = async (codeChallenge) => {
  if (codeChallenge.length > 0) {
    const URL = `${OKTA_HOST}/oauth2/${DEFAULT_KEY_CODE}/v1/authorize?client_id=${CLIENT_CODE}&response_type=code&scope=openid offline_access profile email&redirect_uri=${REDIRECT_URI}&state=state-8600b31f-52d1-4dca-987c-386e3d8967e9&code_challenge_method=S256&code_challenge=${codeChallenge}`;
    window.location.replace(URL);
  }
};
// export const getCustomEntityData = async (tenand_id,bu_id) => {
//   const res= await axios.get(
//     `${apiIpPort}/api/collaborations/customentities/v2?tenant_id=${tenand_id}&bu_id=${bu_id}`,
//     configWithCreds
//   );
//   localStorage.setItem(
//     "customEntityData",
//     JSON.stringify(res?.data?.responseData?.entities ?? [])
//   );}

export async function logout(navigate, dispatch) {
  window.dispatchEvent(new Event("logout"));
  const user = getLocalStorageItem("user");
  const user_id = get(user, "user_id", []);
  const tenant_id = get(user, "tenant_id", []);
  const currentLang = localStorage.getItem("i18nextLng") || "en-US";

  try {
    sendDataToChild({ eventType: ENUM_EVENT.LOGOUT, theme: { logout: true } });
    dispatch(loaderStateChange({ isLoading: true, isParent: true }));
    const url = `${snopEndpoint}/v1/users/logout`;
    const response = await axios.post(url, {}, configWithCreds);
    if (response.status === 200) {
      localStorage.clear();
      sessionStorage.clear();
      navigate(ROUTES_PATH.ROUTE);
    }
    return response;
  } catch (e) {
    if (e?.response?.status === 401) {
      localStorage.clear();
      sessionStorage.clear();
      navigate(ROUTES_PATH.ROUTE);
    }
    return e;
  } finally {
    localStorage.setItem("i18nextLng", currentLang);
    sendDataToChild({ eventType: ENUM_EVENT.LOGOUT, theme: { logout: false } });
    dispatch(loaderStateChange({ isLoading: false, isParent: true }));
    TagManager.dataLayer({
      dataLayer: {
        event: "logout",
        scai_user: user_id,
        scai_tenant: tenant_id,
      },
    });
  }
}

export const getUserSettings = async (token, tenant_id, bu_id) => {
  try {
    const url = `${alertApiEndpoint}/configuration/setting/v1?tenant_id=${tenant_id}&bu_id=${bu_id}`;
    const response = await axios.get(url, configWithCreds);
    return response;
  } catch (e) {
    handleError(e);
  }
};

export const updateSettings = async ({ payload, tenant_id, bu_id }) => {
  try {
    const url = `${snopEndpoint}/configuration/setting/v1?tenant_id=${tenant_id}&bu_id=${bu_id}`;
    const response = await axios.post(url, payload, configWithCreds);
    return response;
  } catch (e) {
    return e;
  }
};
